goog.provide('el8.appchart.dialog.allergyHx');

goog.require('el8.appchart.actions.allergies');
goog.require('el8.appchart.dialog.addEditAllergy');
goog.require('el8.appchart.dialog.addEditIntolerance');
goog.require('el8.template.appchart.dialog.allergyHx');
goog.require('el8.uiwidget.Component');
goog.require('el8.uiwidget.ComponentDialog');


el8.appchart.dialog.allergyHx = (function() {

    var actionsMenu = null;

    var that = new el8.uiwidget.ComponentDialog({
        title: "Allergies and Drug Intolerance History",
        height: function() {
            return el8.app.pageLayout.getChartInnerHeight();
        },
        width: 570,
        contentFn: el8.template.appchart.dialog.allergyHx.content
    });

    var component = new el8.uiwidget.Component({
        dataRenderers: [
            {
                entitySet: el8.ptdata.ptAllergies,
                renderFn: function() {
                    // don't re-render when the dialog isn't open
                    if (!that.isOpen()) { return; }

                    $('.active-allergies-section', that.getContentElt()).html(
                        el8.template.appchart.dialog.allergyHx.allergyList({
                            allergies: el8.ptdata.ptAllergies.getAllActive().map(el8.model.toSoyMapFn),
                            isDocumentedAsNone: el8.ptdata.ptAllergies.isDocumentedAsNone()
                        })
                    );
                    $('.inactive-allergies-section', that.getContentElt()).html(
                        el8.template.appchart.dialog.allergyHx.allergyList({
                            allergies: el8.ptdata.ptAllergies.getAllInactive().map(el8.model.toSoyMapFn),
                            isDocumentedAsNone: el8.ptdata.ptAllergies.isDocumentedAsNone()
                        })
                    );

                    that.adjustPosition();
                },
                events: [{eventName: 'all'}]
            },
            {
                entitySet: el8.ptdata.ptIntolerances,
                renderFn: function() {
                    // don't re-render when the dialog isn't open
                    if (!that.isOpen()) { return; }

                    $('.active-intols-section', that.getContentElt()).html(
                        el8.template.appchart.dialog.allergyHx.intolList({
                            intols: el8.ptdata.ptIntolerances.getAllActive().map(el8.model.toSoyMapFn),
                            isDocumentedAsNone: el8.ptdata.ptIntolerances.isDocumentedAsNone()
                        })
                    );
                    $('.inactive-intols-section', that.getContentElt()).html(
                        el8.template.appchart.dialog.allergyHx.intolList({
                            intols: el8.ptdata.ptIntolerances.getAllInactive().map(el8.model.toSoyMapFn),
                            isDocumentedAsNone: el8.ptdata.ptIntolerances.isDocumentedAsNone()
                        })
                    );

                    that.adjustPosition();
                },
                events: [{eventName: 'all'}]
            }
        ]
    });
    that.setComponent(component);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.more-actions-trigger',  function() {
            var itemId = $(this).data('id');

            var menu;
            var leftOffset;
            if (itemId) {
                var modelClass = el8.model.idToModelClass(itemId);
                if (modelClass === 'PatientAllergy') {
                    var ptAllergy = el8.ptdata.ptAllergies.getById(itemId);
                    menu = el8.appchart.actions.allergies({ item: ptAllergy });
                    leftOffset = 0;
                } else if (modelClass === 'PatientDrugIntolerance') {
                    var ptIntolerance = el8.ptdata.ptIntolerances.getById(itemId);
                    menu = el8.appchart.actions.intols({ item: ptIntolerance });
                    leftOffset = -15;
                }
            }

            actionsMenu.display(
                $(this),
                null,
                { top: 17, left: leftOffset },
                menu
            );
            that.adjustHeight();
            return false;

        }).on('click', '.add-allergy-trigger',  function() {
            el8.appchart.dialog.addEditAllergy.show();

        }).on('click', '.add-intol-trigger',  function() {
            el8.appchart.dialog.addEditIntolerance.show();

        });
    };

    var super_show = that.show;
    that.show = function() {
        super_show.call(that);

        if (!actionsMenu) {
            actionsMenu = new el8.uiwidget.NewActionsMenu({
                container: that.getContentElt(),
                anchorTop: that.getContentElt(),
                menuId: 'allergy-hx-actions-menu'
            });
        }
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        actionsMenu.destroy();
        actionsMenu = null;
    };

    return that;

})();
